import classnames from "classnames";
import PropTypes from "prop-types";
import React, { useState } from "react";
import TrackedButton from "web/react/components/tracked-button/tracked-button";
import { gettext } from "web/script/modules/django-i18n";
import { sortByMultiple } from "web/script/utils/sorting";
import { ColorVariantPropType } from "web/types/color-variant";
import styles from "./color-picker.css";


function Variant({ variant }) {
    let variantClass = classnames(styles.variant, { [styles.oos]: !variant.in_stock });
    let image = <img className={styles.img} src={variant.thumbnail_url} alt={variant.title} />;
    return (
        <li className={variantClass}>
            {variant.in_stock ? (
                <TrackedButton
                    href={variant.url}
                    eventCategory="color_picker"
                    eventAction="clicked"
                    eventLabel=""
                >
                    {image}
                </TrackedButton>
            ) : (
                image
            )}

            {!variant.in_stock && <div className={styles.oosLine} />}
        </li>
    );
}

Variant.propTypes = {
    variant: ColorVariantPropType,
};

function ColorPicker({ canonicalSlug, className, variantLimit, variants }) {
    const [open, setOpen] = useState(false);

    let sortedVariants = sortByMultiple(variants, (variant) => [
        variant.slug === canonicalSlug ? 0 : 1, // the one we're currently on should be first
        variant.in_stock ? 0 : 1, // then we want all in-stock before all oos
        variant.title, // the color. we don't care about order but this will group them together
        variant.slug, // this is unique so will make sure the ordering is consistent
    ]);

    return (
        <div className={classnames(className, styles.wrapper)}>
            <ul className={styles.variants}>
                {sortedVariants.slice(0, variantLimit).map((variant) => {
                    return <Variant key={variant.url} variant={variant} />;
                })}
                {open &&
                    sortedVariants.slice(variantLimit).map((variant) => {
                        return <Variant key={variant.url} variant={variant} />;
                    })}
                {sortedVariants.length > variantLimit && (
                    <li className={styles.more}>
                        <button className={styles.button} onClick={() => setOpen(!open)}>
                            <span>
                                {open ? gettext("general.see_less") : gettext("general.see_more")}
                            </span>
                        </button>
                    </li>
                )}
            </ul>
        </div>
    );
}

ColorPicker.defaultProps = {
    variantLimit: 10,
};

ColorPicker.propTypes = {
    canonicalSlug: PropTypes.string,
    className: PropTypes.string,
    variantLimit: PropTypes.number,
    variants: PropTypes.arrayOf(ColorVariantPropType).isRequired,
};

export default ColorPicker;
